import { render, staticRenderFns } from "./TqLink.vue?vue&type=template&id=d386c5a2&scoped=true&"
import script from "./TqLink.vue?vue&type=script&lang=js&"
export * from "./TqLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d386c5a2",
  null
  
)

export default component.exports